import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { useEffect } from 'react';
import SpaceEsSlider from '../../components/st/SpaceEsSlider';
import { useState } from 'react';
import { reqEsStAction } from '../../modules/es/esItemModule';
import SpaceCardItem from '../../components/st/SpaceCardItem';
//import { isNullableTypeAnnotation } from '../../../../../Library/Caches/typescript/3.9/node_modules/@babel/types/lib/index';
import {isMobileOnly} from 'react-device-detect'

const EstimateSpaceTourBlock = styled.div`
    ${isMobileOnly?`
    width: 100%;
    overflow: scroll;
    position: relative;
    margin-top: 20px;
    //margin-left: -4vw;
    `:`
    width: 100%;
      max-width: 1176px;
      margin: 0 auto; 
    `};

`;

const EstimateSpaceTourTitleBlock = styled.h3`
    margin-bottom: 10px;
    position: relative;
    font-size: 30px;
    text-align: center;
`;

const EstimateSpaceToureGoBlock = styled.div`
    position: absolute;
    top: 6px;
    right: 0;
    font-size: 14px;
    text-decoration: underline;
`
const EstimateSpaceUlBlock = styled.ul`
    float:left;
    width: max-content;
`;

const EstimateSpaceliBlock = styled.li`
    float: left;
`;

const EsItemsListStContainer = ({refSlider}) => {

    const dispatch = useDispatch();

    const { esStItems } = useSelector(
        ({ loadingReducer, esItemsReducer }) => ({
            loading: loadingReducer['esitem/REQ_ES_ST'],
            esStItems: esItemsReducer.esStItems,
        })
    );

    useEffect(() => {
        dispatch(reqEsStAction());
    }, [dispatch])

    if (esStItems === null || esStItems === undefined) {
        return <div />;
    }

    const getMStList = () => {
        return (

                <EstimateSpaceUlBlock className = "clearfix">
                {
                    esStItems.map((curitem,index) => {
                       return(
                            <EstimateSpaceliBlock key={curitem.st_id}>
                                <SpaceCardItem
                                    width={isMobileOnly?'280px':'412px'}
                                    height={isMobileOnly?'300px':'404px'}
                                    iteminfo={curitem}
                                    paddingRight={isMobileOnly? "20px": "31px"}
                                        paddingTop={"0px"}
                                        //height={"337px"}
                                />
                            </EstimateSpaceliBlock>
                        )
                    })
                }
                </EstimateSpaceUlBlock>
        )
    }

    return (
        <EstimateSpaceTourBlock>
            {isMobileOnly? 
            getMStList()
            :
            <SpaceEsSlider items={esStItems} count={esStItems.length} refSlider={refSlider} useEs={false}/>
            }
            
        </EstimateSpaceTourBlock>
    );
};

export default EsItemsListStContainer;
